'use strict';

/* globals window */

var _ = require('lodash');
var React = require('react');

var adQueue = [];
var pooling = false;
var loop;

var Advertise = React.createClass({
    getId: function() {
        return this.props.name;// + '_' + this.props.hash;
    },

    componentDidMount: function() {
        _.defer(this.initiate);
    },

    initiate: function() {
        if (window.bannerDinamico) {
            this.initBanner(this.props.name, this.props.hash);
        } else {
            adQueue.push([this.props.name, this.props.hash]);
            this.startPooling();
        }
    },

    initBanner: function(name/*, hash*/) {
        if (!window.bannerDinamico) return;
        try {
            window.bannerDinamico(name);
        } catch(e) {
            console.warn('Soft error: could not create a dynamic banner');
            console.error(e);
        }
    },

    startPooling: function() {
        if (pooling) return;
        pooling = true;
        loop = setInterval(_.bind(function() {
            var ad;
            if (window.bannerDinamico) {
                clearInterval(loop);
                while (ad = adQueue.shift()) {
                    this.initBanner.apply(this, ad);
                }
            }
        }, this), 1000);
    },

    render: function() {
        return <div id={this.getId()} />;
    }
});

module.exports = Advertise;
